// Registry of kova:// deeplinks the mobile app handles. The app opens this site in a webview
// (arrival marked by ?from=app — useLocationStore().isWebview); views call openDeeplink() to hand
// control back to the app instead of navigating in-page. See ADR 0015.
//
// Adding a deeplink: one line in DEEPLINKS (coordinate the route with the mobile team first).

export const DEEPLINKS = {
	paymentDone: 'kova://payment/done',
} as const satisfies Record<string, `kova://${string}`>

export type DeeplinkName = keyof typeof DEEPLINKS

// Fire-and-forget: custom-scheme navigation has no reliable failure signal. In the webview the app
// intercepts the navigation (and may close the webview); in a plain browser without a handler
// nothing observable happens — by design there is no fallback (ADR 0015).
export function openDeeplink(name: DeeplinkName): void {
	window.location.href = DEEPLINKS[name]
}
